import CitySEOHead from "@/components/feature/CitySEOHead";
import AthensHeroSection from "./components/HeroSection";
import AthensStickyNav from "./components/StickyNav";
import AthensProcessingTimeSection from "./components/ProcessingTimeSection";
import AthensServicesSection from "./components/ServicesSection";
import AthensLocalAreaSection from "./components/LocalAreaSection";
import AthensTestimonialsSection from "./components/TestimonialsSection";
import AthensAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AthensComparisonSection from "./components/ComparisonSection";
import AthensMistakesSection from "./components/MistakesSection";
import AthensHowItWorksSection from "./components/HowItWorksSection";
import AthensFAQSection, { faqs } from "./components/FAQSection";
import AthensHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AthensFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const athensFaqs = faqs as { q: string; a: string }[];

const athensServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function AthensPage() {
  return (
    <>
      <CitySEOHead
        city="Athens"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/athens"
        title="Emergency Passport Athens, GA"
        description="Emergency and expedited passport services in Athens, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving UGA students and northeast Georgia travelers. Get your emergency passport fast!"
        geoPlacename="Athens, Georgia"
        geoPosition="33.9519;-83.3576"
        faqs={athensFaqs}
        servicesSchema={athensServices}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Athens passport, same day passport Athens, fast passport Georgia, UGA passport"
      />
      <div className="font-sans">
        <AthensHeroSection />
        <AthensStickyNav />
        <AthensProcessingTimeSection />
        <AthensLocalAreaSection />
        <AthensServicesSection />
        <AthensTestimonialsSection />
        <AthensAcceptanceFacilitiesSection />
        <AthensComparisonSection />
        <AthensMistakesSection />
        <AthensHowItWorksSection />
        <AthensFAQSection />
        <AthensHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/athens" state="GA" />
        <AthensFinalCTA />
      </div>
    </>
  );
}